import Helper from "./Helper";
import { CountUp } from '../../node_modules/countup.js';

class countUpNumbers {
  constructor(config = {}) {
    const { numbers, numbersWrapper, classIn, classOut, decimalEN, decimalDE, decimalFR, separatorEN, separatorDE, separatorFR } = config;

    this.numbers = document.querySelectorAll(numbers);
    this.numbersArray = Array.prototype.slice.call(this.numbers);
    this.numbersWrapper = numbersWrapper;

    this.classIn = classIn;
    this.classOut = classOut;

    //put all the numbers in array, so they are kept even when function is called several times (and number will not real be detected)
    this.numberObj = [];
    this.numberObj = this.addNumbersToArray(this.numberObj, this.numbersArray);

    //variables for options
    this.decimal = decimalDE;
    this.separator = separatorDE;
    if (document.documentElement.lang === "en-US") {
      this.decimal = decimalEN;
      this.separator = separatorEN;
    } else if (document.documentElement.lang === "fr-FR") {
      this.decimal = decimalFR;
      this.separator = separatorFR;
    }


    this.options = {
      startVal: 0, // number to start at (0)
      decimalPlaces: 0, // number of decimal places (0)
      duration: 4, // animation duration in seconds (2)
      useEasing: true,
      decimal: this.decimal,
      separator: this.separator
    };

    if(this.numbers && this.numbers.length !== 0){
      this.addId(this.numbersArray);
      this.registerScroll();
      this.bindEvents();
    }
  }

  bindEvents() {
    this.numbersArray.forEach((item)=>{
      if (Helper.isInViewport(item)) {
        Helper.addClass(item, this.classIn);
        Helper.removeClass(item, this.classOut);
      } else {
        Helper.removeClass(item, this.classIn);
        Helper.addClass(item, this.classOut);
      }
    });
  }

  registerScroll() {
    window.addEventListener("scroll", e => {
      this.numbersArray.forEach((item, index)=>{
        this.addClassOnScroll(item);
        if(Helper.hasClass(item, this.classIn)){
          if(!Helper.hasClass(item, 'counting')){
            Helper.addClass(item, 'counting');
            this.options.decimalPlaces = this.getDecimal(item);
            const countUp = new CountUp(item.id, this.numberObj[index], this.options);
            countUp.start();
          }
        }
      });
    });
  }

  addClassOnScroll(element){
    if (Helper.isInViewport(element)) {
      Helper.addClass(element, this.classIn);
      Helper.removeClass(element, this.classOut);
    } else {
      Helper.addClass(element, this.classOut);
      Helper.removeClass(element, this.classIn);
    }
  }

  getDecimal(item){
    const parent = Helper.getClosest(item, '.' + this.numbersWrapper);
    let decimal = 0;
    if(Helper.hasClass(parent, this.numbersWrapper + '--has-decimal-1')){
      decimal = 1
    }else if(Helper.hasClass(parent, this.numbersWrapper + '--has-decimal-2')){
      decimal = 2
    }
    return decimal;
  }

  addNumbersToArray(obj, arr){
    arr.forEach((item)=>{
      let anumber = Number(item.innerHTML);
      obj.push(anumber);
    });
    return obj;
  }

  addId(arr){
    arr.forEach((item, index)=>{
      item.id = 'numb' + index;
    });
  }
}

export default countUpNumbers;
